var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUrl = function SvgUrl(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#007BB3",
    d: "M5 16h6a5.2 5.2 0 0 0 5-5 1 1 0 0 0-2 0 3.2 3.2 0 0 1-3 3H5a3.2 3.2 0 0 1-3-3V5a3.2 3.2 0 0 1 3-3 1 1 0 0 0 0-2 5.2 5.2 0 0 0-5 5v6a5.2 5.2 0 0 0 5 5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#007BB3",
    d: "M9 0h6a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0V3.414L9.707 7.707a1 1 0 1 1-1.414-1.414L12.586 2H9a1 1 0 0 1 0-2"
  })));
};
export default SvgUrl;